// #/services/workflows.ts
'use client';

export * from './nodes/createActionNode';
export * from './nodes/createTriggerNode';
export * from './getWorkspace';
export * from '../workflows/updateWorkflow';
export * from './updateWorkspace';

// export const addNodeToWorkspace = async (
//   address: string,
//   id: string,
//   node: Node,
// ): Promise<Workspace> => {
//   const workspace = await getWorkspaceWithNodesAndEdges(address, id);
//   const newNodes = workspace.nodes.concat(node);
//   const updatedWorkspace = { ...workspace, nodes: newNodes };
//   await saveWorkspaceToS3(address, id, updatedWorkspace);
//   return updatedWorkspace;
// };

// export const removeNodeFromWorkspace = async (
//   address: string,
//   id: string,
//   nodeId: string,
// ): Promise<Workspace> => {
//   const workspace = await getWorkspaceWithNodesAndEdges(address, id);
//   const newNodes = workspace.nodes.filter((node) => node.id !== nodeId);
//   const updatedWorkspace = { ...workspace, nodes: newNodes };
//   await saveWorkspaceToS3(address, id, updatedWorkspace);
//   return updatedWorkspace;
// };

// export const addEdgeToWorkspace = async (
//   address: string,
//   id: string,
//   edge: Edge,
// ): Promise<Workspace> => {
//   const workspace = await getWorkspaceWithNodesAndEdges(address, id);
//   const newEdges = workspace.edges.concat(edge);
//   const updatedWorkspace = { ...workspace, edges: newEdges };
//   await saveWorkspaceToS3(address, id, updatedWorkspace);
//   return updatedWorkspace;
// };

// export const removeEdgeFromWorkspace = async (
//   address: string,
//   id: string,
//   edgeId: string,
// ): Promise<Workspace> => {
//   const workspace = await getWorkspaceWithNodesAndEdges(address, id);
//   const newEdges = workspace.edges.filter((edge) => edge.id !== edgeId);
//   const updatedWorkspace = { ...workspace, edges: newEdges };
//   await saveWorkspaceToS3(address, id, updatedWorkspace);
//   return updatedWorkspace;
// };

// export const updateNodeInWorkspace = async (
//   address: string,
//   id: string,
//   updatedNode: Node,
// ): Promise<Workspace> => {
//   const workspace = await getWorkspaceWithNodesAndEdges(address, id);
//   const updatedNodes = workspace.nodes.map((node) => {
//     if (node.id === updatedNode.id) {
//       return updatedNode;
//     }
//     return node;
//   });
//   const updatedWorkspace = { ...workspace, nodes: updatedNodes };
//   await saveWorkspaceToS3(address, id, updatedWorkspace);
//   return updatedWorkspace;
// };

// export const updateEdgeInWorkspace = async (
//   address: string,
//   id: string,
//   updatedEdge: Edge,
// ): Promise<Workspace> => {
//   const workspace = await getWorkspaceWithNodesAndEdges(address, id);
//   const updatedEdges = workspace.edges.map((edge) => {
//     if (edge.id === updatedEdge.id) {
//       return updatedEdge;
//     }
//     return edge;
//   });
//   const updatedWorkspace = { ...workspace, edges: updatedEdges };
//   await saveWorkspaceToS3(address, id, updatedWorkspace);
//   return updatedWorkspace;
// };

// export const updateWorkspace = async (
//   address: string,
//   id: string,
//   updatedWorkspace: Workspace,
// ): Promise<Workspace> => {
//   await saveWorkspaceToS3(address, id, updatedWorkspace);
//   return updatedWorkspace;
// };
